module.exports = __webpack_public_path__ + "images/interview-Paypal-2.svg";